import React from "react";
import "./CheckboxInput.scss";
import DOMPurify from "dompurify";
import FieldDisabled from "../FieldDisabled";

const CheckboxInput = ({
  input,
  meta,
  schemaProps: {
    machine_name,
    choice,
    label,
    disableWhenField,
    clearSchema,
    setSchema,
    choiceLabelHidden,
  },
  disabledViaReuse,
  ...rest
}) => {
  let checked = false;
  let disabled = false;
  let isDisabled = false;

  if (
    rest.formApi &&
    rest.formApi.getFieldState(machine_name) &&
    rest.formApi.getFieldState(machine_name).value !== undefined &&
    rest.formApi.getFieldState(machine_name).value !== null &&
    typeof rest.formApi.getFieldState(machine_name).value !== "object" &&
    rest.formApi.getFieldState(machine_name).value === 1
  ) {
    checked = true;
  }
  // integrating with shared FieldDisabled logic
  if (disableWhenField !== undefined) {
    if (typeof disableWhenField === "string") {
      isDisabled = FieldDisabled(null, disableWhenField, rest.formApi);
    } else {
      isDisabled = FieldDisabled(
        null,
        disableWhenField.when,
        rest.formApi,
        undefined,
        disableWhenField.is,
        disableWhenField.type
      );
    }
  } else if (!!disabledViaReuse) {
    isDisabled = disabledViaReuse;
  } else {
    isDisabled = disabled;
  }
  // clearing schema based on check
  let clearFields = () => {
    clearSchema.forEach((c) => {
      // set to undefined to remove actual field from payload
      // set to null to keep field but have the value be a null type
      rest.formApi.change(c, null);
    });
  };

  let setFields = () => {
    // RadioInput has more indepth logic if better logic needs to be implemented
    setSchema.forEach((c) => {
      rest.formApi.change(c.set, c.to);
    });
  };

  const checkBoxEvent = (e) => {
    if (rest.formApi.getFieldState(machine_name).value === 1) {
      //unchecked
      rest.formApi.change(machine_name, 0);
      //this checks and unchecks it
      input.onChange(0);
    } else {
      //checked
      rest.formApi.change(machine_name, 1);
      input.onChange(1);
    }
    clearSchema && clearFields();
    setSchema && setFields();
  };
  const displayChoice = choiceLabelHidden
    ? {
        display: "block",
        opacity: 0,
        width: 0,
        height: 0,
        lineHeight: 0,
        overflow: "hidden",
      }
    : {};

  return (
    <div className="usa-checkbox" key={`${machine_name}-checkbox`}>
      <input
        key={machine_name}
        {...input}
        onChange={checkBoxEvent}
        checked={checked}
        name={machine_name}
        id={machine_name + label}
        className={`usa-checkbox__input`}
        type="checkbox"
        disabled={isDisabled}
      />
      <label
        className="usa-checkbox__label"
        htmlFor={machine_name + label}
        // key={machine_name}
      >
        <span
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(choice) }}
          // 508s: Empty checkboxes still need a name/text, so giving it invisiable choice label. Ideally we should refactor for 9089's section H.d and connect the checkbox with the label from second column.
          style={displayChoice}
        />
      </label>
    </div>
  );
};

export default CheckboxInput;
